import _index from "./internal/index.js";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var internal = _index;
Object.defineProperty(exports, "SvelteComponent", {
  enumerable: true,
  get: function () {
    return internal.SvelteComponentDev;
  }
});
Object.defineProperty(exports, "SvelteComponentTyped", {
  enumerable: true,
  get: function () {
    return internal.SvelteComponentTyped;
  }
});
Object.defineProperty(exports, "afterUpdate", {
  enumerable: true,
  get: function () {
    return internal.afterUpdate;
  }
});
Object.defineProperty(exports, "beforeUpdate", {
  enumerable: true,
  get: function () {
    return internal.beforeUpdate;
  }
});
Object.defineProperty(exports, "createEventDispatcher", {
  enumerable: true,
  get: function () {
    return internal.createEventDispatcher;
  }
});
Object.defineProperty(exports, "getAllContexts", {
  enumerable: true,
  get: function () {
    return internal.getAllContexts;
  }
});
Object.defineProperty(exports, "getContext", {
  enumerable: true,
  get: function () {
    return internal.getContext;
  }
});
Object.defineProperty(exports, "hasContext", {
  enumerable: true,
  get: function () {
    return internal.hasContext;
  }
});
Object.defineProperty(exports, "onDestroy", {
  enumerable: true,
  get: function () {
    return internal.onDestroy;
  }
});
Object.defineProperty(exports, "onMount", {
  enumerable: true,
  get: function () {
    return internal.onMount;
  }
});
Object.defineProperty(exports, "setContext", {
  enumerable: true,
  get: function () {
    return internal.setContext;
  }
});
Object.defineProperty(exports, "tick", {
  enumerable: true,
  get: function () {
    return internal.tick;
  }
});
export default exports;
export const __esModule = exports.__esModule,
      SvelteComponent = exports.SvelteComponent,
      SvelteComponentTyped = exports.SvelteComponentTyped,
      afterUpdate = exports.afterUpdate,
      beforeUpdate = exports.beforeUpdate,
      createEventDispatcher = exports.createEventDispatcher,
      getAllContexts = exports.getAllContexts,
      getContext = exports.getContext,
      hasContext = exports.hasContext,
      onDestroy = exports.onDestroy,
      onMount = exports.onMount,
      setContext = exports.setContext,
      tick = exports.tick;